import Kfit from '../integrations/Kfit';

export const claimVoucher = params =>
  Kfit.post('/v4/redemptions', params).then(res => res);
